import controller from './case-check-modal';
import template from './case-check-modal.pug';

class CaseCheckService {
  /* @ngInject */
  constructor($uibModal, $http) {
    this.$uibModal = $uibModal;
    this.$http = $http;
  }

  open(check, caseId, caseCheck) {
    return this
      .$uibModal
      .open({
        size: 'md',
        animation: true,
        template,
        controller,
        controllerAs: '$ctrl',
        resolve: {
          check: () => check,
          caseId: () => caseId,
          caseCheck: () => caseCheck,
        },
      })
      .result;
  }
}

export default CaseCheckService;



// WEBPACK FOOTER //
// ./client/components/case-check-modal/case-check-modal.service.js